import axios from '../..';

export const fetchDashboard = () => axios.get(`api/admin/dashboard`);
